<script>
	import Steps from '../Steps';
	import swal from 'sweetalert';
	import DatePicker from 'vue2-datepicker';
	import { mapState,mapMutations } from 'vuex';
	import AddExclude from '../modals/AddExclude.vue';
	import SearchFormat from '../modals/SearchFormat.vue';
	import {stepThreeTarget} from '../../stepsTargets.js';	

	import vSelect from 'vue-select'
	import 'vue-select/dist/vue-select.css';

	export default{
		props:{
			reviewApprove: {
				type: Boolean,
				default: false
			}
		},
		components:{Steps,AddExclude,DatePicker,vSelect,SearchFormat},
		data(){
			return {
				tablaAportaciones:false,
				nuevoNivel:false,
				nuevaJerarquia:false,
				format: '',
				d:'',
				s:'',
				f:'',
				t:'',
				showItems:false,
				formatSuccess:false,
				options: [
				{'code': 506, 'label':'Promociones'},
				{'code': 508, 'label':'Otros'},
				{'code': 510, 'label':'Proveedor preferente'},
				{'code': 511, 'label':'Bonif. Vol Fundament'},
				{'code': 512, 'label':'Bonif. Vol Desempeño'},
				{'code': 513, 'label':'Bonificación volumen'},
				{'code': 515, 'label':'Protección de precio'},
				{'code': 516, 'label':'Re/Apertura tienda'},
				{'code': 521, 'label':'Pronto pago'},
				{'code': 524, 'label':'MDM Desc Confiden'},
				{'code': 527, 'label':'Volumen Sobre Ventas'},
				{'code': 528, 'label':'Aportaciones Cliente'},
				],
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Terminar paso'
					}
				},
				myCallbacks: {
					onNextStep: this.myCustomNextStepCallback,
					onPreviousStep: this.myCustomPreviousStepCallback,
					onStop: this.myCustomStopCallback
				}
			}
		},
		computed:{
			...mapState(['stepActive','stepTwo','stepThree','ejercicioActivo','alertas','tiendaSeleccionada']),
			tipoDeAportacion(){
				return this.stepThree.tipoDeAportacion;
			},
			baseDeCalculo(){
				return this.stepThree.baseDeCalculo;
			},
			departamento(){
				return this.stepThree.jerarquias.departamento;
			},
			niveles(){
				return this.stepThree.niveles;
			},
			tipoDeTarifa(){
				return this.stepThree.tipoDeTarifaNivel;
			},
			steps(){
				return stepThreeTarget(this.tiendaSeleccionada);
			},
			tipoDeDistribucion(){
				return this.stepThree.tipoDeDistribucion;
			}
		},
		watch:{
			tipoDeDistribucion(){
				if(this.stepThree.tipoDeDistribucion != 'Todas las tiendas'){
					swal({title: "¡Atención!",text: 'Este ejercicio es para todas las tiendas.',icon: "warning",button: 'Aceptar'});					
				}
			},
			tipoDeAportacion(){
				if(this.ejercicioActivo == 'ejercicio-1' || this.ejercicioActivo == 'ejercicio-3'){
					if(this.stepThree.tipoDeAportacion != '' && this.stepThree.tipoDeAportacion.code != 513){
						swal({title: "¡Atención!",text: 'El tipo de aportación debe corresponder al ejercicio.',icon: "warning",button: 'Aceptar'})
						.then(() => {
							this.stepThree.tipoDeAportacion = '';
							this.stepThree.descripcionAportacion = '';
						});
					}
				}

				if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-4'){
					if(this.stepThree.tipoDeAportacion != '' && this.stepThree.tipoDeAportacion.code != 506){
						swal({title: "¡Atención!",text: 'El tipo de aportación debe corresponder al ejercicio.',icon: "warning",button: 'Aceptar'})
						.then(() => {
							this.stepThree.tipoDeAportacion = '';
							this.stepThree.descripcionAportacion = '';
						});
					}
				}
			},
			baseDeCalculo(){
				if(this.ejercicioActivo == 'ejercicio-1' || this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-3' || this.ejercicioActivo == 'ejercicio-4'){
					if(this.stepThree.baseDeCalculo != '' && this.stepThree.baseDeCalculo != 'Recepcion'){
						swal({title: "¡Atención!",text: 'La base de cálculo no corresponde al ejercicio.',icon: "warning",button: 'Aceptar'})
						.then(() => this.stepThree.baseDeCalculo = '');
					}
				}
			},
			niveles(){
				if(this.ejercicioActivo == 'ejercicio-1' || this.ejercicioActivo == 'ejercicio-3'){
					this.stepThree.monedaUM = 'MXN';
					if(this.stepThree.niveles != '' && this.stepThree.niveles != 'Monto'){
						swal({title: "¡Atención!",text: 'Este ejercicio es un monto por volumen.',icon: "warning",button: 'Aceptar'})
						.then(() => this.stepThree.niveles = '');
					}	
				}

				if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-4'){
					this.stepThree.monedaUM = 'EA';
					if(this.stepThree.niveles != '' && this.stepThree.niveles != 'Cantidad'){
						swal({title: "¡Atención!",text: 'Este ejercicio es de cantidad por volumen.',icon: "warning",button: 'Aceptar'})
						.then(() => this.stepThree.niveles = '');
					}	
				}
			},
			tipoDeTarifa(){
				if(this.ejercicioActivo == 'ejercicio-1' || this.ejercicioActivo == 'ejercicio-3'){
					if(this.stepThree.tipoDeTarifaNivel != '' && this.stepThree.tipoDeTarifaNivel != 'Porcentual'){
						swal({title: "¡Atención!",text: 'Este ejercicio es un porcentaje por volumen de compra.',icon: "warning",button: 'Aceptar'})
						.then(() => this.stepThree.tipoDeTarifaNivel = '');
					}	
				}

				if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-4'){
					if(this.stepThree.tipoDeTarifaNivel != '' && this.stepThree.tipoDeTarifaNivel != 'Monto por Cantidad'){
						swal({title: "¡Atención!",text: 'Este ejercicio es un Monto por cantidad de compra.',icon: "warning",button: 'Aceptar'})
						.then(() => this.stepThree.tipoDeTarifaNivel = '');
					}	
				}
			}
		},
		mounted(){
			this.stepThree.valdioDe = this.stepTwo.validoDesdeFecha;
			this.stepThree.validezA = this.stepTwo.validoHastaFecha;

			if(this.stepActive == 3 && this.alertas){
				this.$tours['stepThree'].start();
			}

			if(!this.alertas){
				this.showItems = true;
			}

			if(this.stepThree.formato.length > 0){
				this.format = 'Múltiples valores seleccionados';
			}
		},
		methods:{
			...mapMutations(['changeStepActive','saveStepThree']),
			changeType(e){
				this.stepThree.descripcionAportacion = e.label;
			},
			saveStep(stepC){
				if(this.ejercicioActivo != 'evaluacion-1' && this.ejercicioActivo != 'evaluacion-2'){
					if(this.stepThree.tipoDeAportacion != '' &&
						this.stepThree.baseDeCalculo != '' &&
						this.stepThree.jerarquias.departamento != '' &&
						this.stepThree.tarifa != '' &&
						this.stepThree.baseArticulo != '' &&
						this.stepThree.niveles != '' &&
						this.stepThree.tipoDeTarifaNivel != '' &&
						this.stepThree.formato != '' &&
						this.stepThree.tipoDeDistribucion != ''){

						if(this.ejercicioActivo == 'ejercicio-1'){

							if(this.stepThree.jerarquias.subclase == '' || this.stepThree.jerarquias.fineline == ''){
								swal({title: "¡Atención!",text: 'Antes de continuar debes llenar toda la información del ejercicio.',icon: "error",button: 'Aceptar'});
							}else{
								this.changeStepActive(this.stepActive+1);
								this.saveStepThree(this.stepThree);	
							}

						}

						if(this.ejercicioActivo == 'ejercicio-2'){

							if(!this.stepThree.articulo){
								swal({title: "¡Atención!",text: 'Antes de continuar debes ingresar los articulos de este ejercicio.',icon: "error",button: 'Aceptar'});
							}else{
								this.changeStepActive(this.stepActive+1);
								this.saveStepThree(this.stepThree);	
							}

						}

						if(this.ejercicioActivo == 'ejercicio-3'){
							if(!this.stepThree.articulo){
								swal({title: "¡Atención!",text: 'Antes de continuar debes ingresar los articulos de este ejercicio.',icon: "error",button: 'Aceptar'});
							}else{
								this.changeStepActive(this.stepActive+1);
								this.saveStepThree(this.stepThree);	
							}
						}

						if(this.ejercicioActivo == 'ejercicio-4'){
							if(this.stepThree.jerarquias.subclase == ''){
								swal({title: "¡Atención!",text: 'Antes de continuar debes llenar toda la información del ejercicio.',icon: "error",button: 'Aceptar'});
							}else{
								if(!this.stepThree.articulo){
									swal({title: "¡Atención!",text: 'Antes de continuar debes ingresar los articulos de este ejercicio.',icon: "error",button: 'Aceptar'});
								}else{
									this.changeStepActive(this.stepActive+1);
									this.saveStepThree(this.stepThree);	
								}
							}
						}
						


					}else{
						swal({title: "¡Atención!",text: 'Antes de continuar debes llenar toda la información del ejercicio.',icon: "error",button: 'Aceptar'});
					}
				}else{
					this.changeStepActive(stepC);
					this.saveStepThree(this.stepThree);	
				}
				

			},
			showFormato(){
				window.$('#search-format').modal('show');
			},
			onInput(evt,model,index){
				this.stepThree.jerarquias[index][model] = evt.target.innerText;
			},
			onInputTipos(evt,model){
				this.stepThree[model] = window.$.trim(evt.target.innerText);
				this.t = window.$.trim(evt.target.innerText);
				window.$(evt.target).find('br').remove();

				if(this.ejercicioActivo == 'ejercicio-1'){
					if(evt.target.innerText.length >= 1){
						if(window.$.trim(evt.target.innerText) != '3' && window.$.trim(evt.target.innerText) != '3%'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
					}	
				}
				
				if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-4'){

					let tarifaTMP = window.$.trim(evt.target.innerText);

					switch(tarifaTMP.length) {
						case 1:
						if(tarifaTMP != '4'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						case 2:
						if(tarifaTMP != '43'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						case 3:
						if(tarifaTMP != '431'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						case 4:
						if(tarifaTMP != '431.'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						case 5:
						if(tarifaTMP != '431.0'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						case 6:
						if(tarifaTMP != '431.03'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						default:
						if(tarifaTMP != '431.03'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;

					}
				}

				if(this.ejercicioActivo == 'ejercicio-3'){
					let tarifaTMP = window.$.trim(evt.target.innerText);

					switch(tarifaTMP.length) {
						case 1:
						if(tarifaTMP != '1'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						case 2:
						if(tarifaTMP != '1.'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						case 3:
						if(tarifaTMP != '1.7'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
						default:
						if(tarifaTMP != '1.7'){
							swal({title: "¡Atención!",text: 'La tarifa no corresponde con el ejercicio.',icon: "warning",button: 'Aceptar'});
							evt.target.innerText = '';
						}
						break;
					}

				}
			},
			myCustomNextStepCallback (currentStep) {
				if (currentStep == 4) {
					this.showItems = true;
				}
			},
			myCustomPreviousStepCallback (currentStep) {
				if (currentStep == 5) {
					this.showItems = false;
				}
			},
			myCustomStopCallback(){
				this.showItems = true;
			},
			setDepartamento(evt){
				window.$(evt.target).find('br').remove();
				this.d += evt.data;


				if(evt.data == null){
					this.d = evt.target.innerText;
				}
				let departamento = window.$.trim(this.d);

				if(departamento == ''){
					this.stepThree.jerarquias.departamento = '';
					this.stepThree.jerarquias.descripcionDepartamento = '';
				}


				if(this.ejercicioActivo == 'ejercicio-1'){
					if(departamento.length >= 2){
						if(departamento != '92'){
							swal({title: "¡Atención!",text: 'El departamento debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
							.then(() => {
								this.d = '';
								window.$('#depE1').html('');
								this.stepThree.jerarquias.departamento = '';
								this.stepThree.jerarquias.descripcionDepartamento = '';
							});
						}

						if(departamento == '92'){
							this.stepThree.jerarquias.departamento = '92';
							this.stepThree.jerarquias.descripcionDepartamento = 'ABARROTES BÁSICOS';

							swal({
								title: "¡Recuerda!",
								text: 'Cuando la negociación tiene FineLine la SubClase siempre será 00.',
								icon: "warning",
								button: 'Aceptar'
							});
						}
					}
				}

				if(this.ejercicioActivo == 'ejercicio-2'){
					if(departamento != '05' && departamento != '5'){
						swal({title: "¡Atención!",text: 'El departamento debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
						.then(() => {
							this.d = '';
							window.$('#depE1').html('');
							this.stepThree.jerarquias.departamento = '';
							this.stepThree.jerarquias.descripcionDepartamento = '';
						});
					}

					if(departamento == '0005' || departamento == '5' || departamento == '05'){
						this.stepThree.jerarquias.departamento = '0005';
						this.stepThree.jerarquias.descripcionDepartamento = 'ELECTRÓNICA';
					}
				}

				if(this.ejercicioActivo == 'ejercicio-3'){
					if(departamento.length >= 2){
						if(departamento != '13'){
							swal({title: "¡Atención!",text: 'El departamento debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
							.then(() => {
								this.d = '';
								window.$('#depE2').html('');
								this.stepThree.jerarquias.departamento = '';
								this.stepThree.jerarquias.descripcionDepartamento = '';
							});
						}

						if(departamento == '13' || departamento == '013'){
							this.stepThree.jerarquias.departamento = '013';
							this.stepThree.jerarquias.descripcionDepartamento = 'LIMPIEZA';
							window.$('#subE2').trigger('focus');
						}
					}
				}

				if(this.ejercicioActivo == 'ejercicio-4' || this.ejercicioActivo == 'evaluacion-2'){
					if(departamento.length >= 2){
						if(departamento != '94'){
							swal({title: "¡Atención!",text: 'El departamento debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
							.then(() => {
								this.d = '';
								window.$('#depE2').html('');
								this.stepThree.jerarquias.departamento = '';
								this.stepThree.jerarquias.descripcionDepartamento = '';
							});
						}

						if(departamento == '94' || departamento == '094'){
							this.stepThree.jerarquias.departamento = '94';
							this.stepThree.jerarquias.descripcionDepartamento = 'AIRES ACONDICIONADO..';
						}
					}
				}


				if(this.ejercicioActivo == 'evaluacion-1'){
					if(departamento.length >= 2){
						if(departamento == '90'){
							this.stepThree.jerarquias.departamento = '90';
							this.stepThree.jerarquias.descripcionDepartamento = 'LÁCTEOS';
						}
					}
				}
			},
			setSubclase(evt){
				window.$(evt.target).find('br').remove();

				this.s += evt.data;
				if(evt.data == null){
					this.s = evt.target.innerText;
				}
				let subclase = window.$.trim(this.s);
				
				if(subclase == ''){
					this.stepThree.jerarquias.subclase = '';
					this.stepThree.jerarquias.descripcionSubclase = '';
				}

				if(this.d == '90' && (subclase == '0000000000' || subclase == '00')){
					this.stepThree.jerarquias.subclase = '0000000000';
					this.stepThree.jerarquias.descripcionSubclase = 'UNKNOWN';
				}

				if(this.d == '92' && (subclase == '0000000000' || subclase == '00')){
					this.stepThree.jerarquias.subclase = '0000000000';
					this.stepThree.jerarquias.descripcionSubclase = 'NON-LIKE ASST';
				}

				if(subclase == '004' || subclase == '04' || subclase == '4'){
					this.stepThree.jerarquias.subclase = '004';
					this.stepThree.jerarquias.descripcionSubclase = 'Ventiladores de techo';
				}

				if(this.ejercicioActivo == 'ejercicio-4'){

					switch(subclase.length) {
						case 1:
						if(subclase != '0'){
							swal({title: "¡Atención!",text: 'La Subcategoría debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
							.then(() => {
								this.s = '';
								window.$('#subE2').html('');
								this.stepThree.jerarquias.subclase = '';
								this.stepThree.jerarquias.descripcionSubclase = '';
							});	
						}
						break;
						case 2:
						if(subclase != '00'){
							swal({title: "¡Atención!",text: 'La Subcategoría debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
							.then(() => {
								this.s = '';
								window.$('#subE2').html('');
								this.stepThree.jerarquias.subclase = '';
								this.stepThree.jerarquias.descripcionSubclase = '';
							});	
						}
						break;
						case 3:
						if(subclase != '004'){
							swal({title: "¡Atención!",text: 'La Subcategoría debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
							.then(() => {
								this.s = '';
								window.$('#subE2').html('');
								this.stepThree.jerarquias.subclase = '';
								this.stepThree.jerarquias.descripcionSubclase = '';
							});	
						}
						break;
						default:
						if(subclase != '004'){
							swal({title: "¡Atención!",text: 'La Subcategoría debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'})
							.then(() => {
								this.s = '';
								window.$('#subE2').html('');
								this.stepThree.jerarquias.subclase = '';
								this.stepThree.jerarquias.descripcionSubclase = '';
							});	
						}
						break;
					}

					

				}
			},
			setFineline(evt){
				window.$(evt.target).find('br').remove();

				this.f += evt.data;
				if(evt.data == null){
					this.f = evt.target.innerText;
				}
				let fineline = window.$.trim(this.f);

				if(fineline == ''){
					this.stepThree.jerarquias.fineline = '';
					this.stepThree.jerarquias.descripcionFineline = '';
				}

				if(this.ejercicioActivo == 'evaluacion-1'){
					if(fineline.length >= 4){
						if(fineline == '1301'){
							this.stepThree.jerarquias.fineline = '1301';
							this.stepThree.jerarquias.descripcionFineline = 'Margarinas';
						}
					}
				}

				if(this.ejercicioActivo == 'ejercicio-1'){
					if(this.s.length < 2){
						this.f = '';
						window.$('#fineLineDOM').html('');
						swal({title: "¡Atención!",text: 'Debes ingresar la subclase para capturar la FineLine.',icon: "warning",button: 'Aceptar'});
					}else{
						if(fineline.length >= 4){
							if(fineline == '2601'){
								this.stepThree.jerarquias.fineline = '2601';
								this.stepThree.jerarquias.descripcionFineline = 'TORTILLA DE HARINA';
							}else{
								swal({title: "¡Atención!",text: 'La FineLine debe corresponder con el ejercicio.',icon: "warning",button: 'Aceptar'});
							}
						}
					}

				}
			},
			setFormato(evt){
				this.stepThree.formato = evt;
				this.format = 'Múltiples valores seleccionados';
			},
			restartTour(){
				this.$tours['stepThree'].start();
				this.showItems = false;
			},
			anadirJerarquia(){
				this.nuevaJerarquia = true;
				if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-4'){
					swal({title: "¡Atención!",text: 'No olvides capturar los artículos de este ejercicio.',icon: "warning",button: 'Aceptar'});
				}
			}
		}
	}
</script>
<template>
	<div class="contenido">
		<v-tour name="stepThree" :steps="steps" :options="myOptions" :callbacks="myCallbacks"/>
		<div v-if="!reviewApprove">
			<div class="header-tools">
				<div class="title">
					Crear Solicitud Acuerdo: Paso 3 (Aportación)
				</div>
				<div class="buttons">
					<div>
						<button @click="saveStep(stepActive-1)"> <i class="fas fa-chevron-left"></i> Atrás </button>
						<button data-v-step="32" @click="saveStep(stepActive+1)">Continuar <i class="fas fa-chevron-right"></i></button>
						<span class="separator-buttons">|</span>
						<button> Guardar </button>
						<button> Cancelar </button>
						| <button v-if="alertas" @click="restartTour()" class="btn-icon"><i class="fas fa-question-circle"></i> Instrucciones</button>
					</div>
				</div>
			</div>
			<steps :stepActive="stepActive"/>
			<hr class="separator-steps-content">
		</div>
		<div class="container">
			<div class="information-general">
				<div class="title">
					Aportaciones
				</div>
				<div class="info-body">
					<div class="row">
						<div class="col-md-8">
							<div class="row mb-10">
								<div class="col-md-4">Nueva Solicitud Acuerdo</div>
								<div class="col-md-4">Tipo Sol. Acuerdo: Volumen</div>
								<div class="col-md-4">Solicitud Acuerdo:</div>
							</div>
							<div class="row mb-25">
								<div class="col-md-4">
									Estado: Borrador Solicitud Acuerdo
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-9 mt-10">
				<div class="row">
					<div class="col-md-4">
						<div class="form-group" data-v-step="19">
							<label for="" class="control-label i">Tipo de Aportación: <a class="a-blue-link pull-right ml-25">¿Ayuda?</a></label>

							<v-select @input="changeType" placeholder=""  v-model="stepThree.tipoDeAportacion" :options="options"  label="code">
								<template slot="option" slot-scope="option">
									<div class="option-type-contribution">
										<div>{{option.label}}</div>
										<div>{{option.code}}</div>
									</div>
								</template>
							</v-select>
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group" data-v-step="20">
							<label for="" class="control-label i">Descripción Aportación:</label>
							<input type="text" v-model="stepThree.descripcionAportacion" class="form-control" value="Bonificación volumen">
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label">Válido de:</label>
							<date-picker v-model="stepThree.valdioDe" type="date" lang="es" format="YYYY-MM-DD" confirm confirm-text="Aplicar" placeholder=""/>
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group" data-v-step="21">
							<label for="" class="control-label">Validez a:</label>
							<date-picker v-model="stepThree.validezA" type="date" lang="es" format="YYYY-MM-DD" confirm confirm-text="Aplicar" placeholder=""/>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4">
						<div class="form-group" data-v-step="22">
							<label for="" class="control-label i">Base de cálculo:</label>
							<select v-model="stepThree.baseDeCalculo" class="form-control">
								<option value="Recepcion">Recepción</option>
								<option value="POS">POS</option>
							</select>
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group" data-v-step="23">
							<label for="" class="control-label i">Tipo de Devolución:</label>
							<select v-model="stepThree.tipoDeDevolucion" class="form-control">
								<option value="No incluir">No incluir</option>
								<option value="Incluir">Incluir</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="subtitle-content">
				Jerarquía Comercial
			</div>
			<div class="row">
				<div class="col-md-11 table-options">
					<div class="buttons">
						<button> Export </button>
						<button data-v-step="48" @click="anadirJerarquia()"> Nueva línea </button>
						<button> Borrar línea </button>
					</div>
					<table v-if="ejercicioActivo == 'ejercicio-1' || ejercicioActivo == 'ejercicio-2' || ejercicioActivo == 'evaluacion-1'" class="table-proveedor  table-not-hover">
						<tr>
							<td><i class="far fa-clone"></i></td>
							<td>Departamento</td>
							<td>Descripción Departamento</td>
							<td>Subclase</td>
							<td>Descripción de Subclase</td>
							<td>Fineline</td>
							<td>Descripción de Fineline</td>
							<td>Excluir</td>
							<td>Arts</td>
						</tr>
						<tr v-if="nuevaJerarquia || reviewApprove || stepThree.jerarquias.departamento != ''">
							<td>&nbsp;</td>

							<td id="depE1" @paste="setDepartamento($event)" @input="setDepartamento($event)" contenteditable="">
								{{d == '' ? stepThree.jerarquias.departamento:''}}
							</td>
							<td>{{stepThree.jerarquias.descripcionDepartamento}}</td>
							<td @paste="setSubclase($event)" @input="setSubclase($event)" contenteditable="">
								{{s == '' ? stepThree.jerarquias.subclase:''}}
							</td>
							<td>{{stepThree.jerarquias.descripcionSubclase}}</td>
							<td id="fineLineDOM" @paste="setFineline($event)" @input="setFineline($event)" contenteditable="">
								{{f == '' ? stepThree.jerarquias.fineline:''}}
							</td>
							<td>{{stepThree.jerarquias.descripcionFineline}}</td>

							<td><input type="checkbox"></td>
							<td><a class="a-blue-link" data-toggle="modal" data-target="#add-exclude">Agregar/Excluir</a></td>
						</tr>
						<tr v-if="!nuevaJerarquia && !reviewApprove && !stepThree.jerarquias.departamento">
							<td>&nbsp;</td>
							<td colspan="8">La tabla no contiene datos.</td>
						</tr>
					</table>

					<table v-if="ejercicioActivo == 'ejercicio-3' || ejercicioActivo == 'ejercicio-4' || ejercicioActivo == 'evaluacion-2'" class="table-proveedor table-not-hover">
						<tr>
							<td><i class="far fa-clone"></i></td>
							<td>Categoría Sams</td>
							<td>Descripción Categoría Sams</td>
							<td>Sams Sub Categoría</td>
							<td>Descripción de Subcategoría</td>
							<td>Excluir</td>
							<td>Arts</td>
						</tr>
						<tr >
							<td>&nbsp;</td>

							<td id="depE2" @input="setDepartamento($event)" contenteditable="">
								{{d == '' ? stepThree.jerarquias.departamento:''}}
							</td>
							<td>{{stepThree.jerarquias.descripcionDepartamento}}</td>
							<td id="subE2" @input="setSubclase($event)" contenteditable="">
								{{s == '' ? stepThree.jerarquias.subclase:''}}
							</td>
							<td>{{stepThree.jerarquias.descripcionSubclase}}</td>

							<td><input type="checkbox"></td>
							<td><a class="a-blue-link" data-toggle="modal" data-target="#add-exclude">Agregar/Excluir</a></td>
						</tr>
					</table>
					<add-exclude :tienda="51"/>
				</div>
			</div>
			<div v-if="showItems || reviewApprove">
				<div class="row">
					<div class="col-md-12 mt-25">
						<div class="checkbox" data-v-step="41">
							<label class="fz-13">
								<input disabled="" type="checkbox" v-model="stepThree.autoAgregarArticulos" name="autoPush"> 
								Auto Agregar Artículos(campos del sistema para indicar que nuevos artículos agregados a la jerarquía sean incluidos en el acuerdo)
							</label>
						</div>
					</div>
				</div>
				<div class="subtitle-content">
					Niveles
				</div>
				<div class="col-md-9 mt-10">
					<div class="row">
						<div class="col-md-4">
							<div class="form-group" data-v-step="45">
								<label for="" class="control-label i">Base Artículo:</label>
								<select v-model="stepThree.baseArticulo" class="form-control">
									<option value="Grupo Artículos">Grupo Artículos</option>
									<option value="Artículos Individuales">Artículos Individuales</option>
								</select>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group" data-v-step="24">
								<label for="" class="control-label i">Niveles:</label>
								<select v-model="stepThree.niveles" class="form-control">
									<option value="Peso">Peso</option>
									<option value="Cantidad">Cantidad</option>
									<option value="Monto">Monto</option>
								</select>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<label for="" class="control-label i">Tipo de tarifa Nivel:</label>
								<select v-model="stepThree.tipoDeTarifaNivel" class="form-control">

									<option v-if="stepThree.niveles == 'Peso'" value="Monto por peso">Monto por peso</option>
									<option v-if="stepThree.niveles == 'Peso'" value="Monto Fijo">Monto Fijo</option>
									<option v-if="stepThree.niveles == 'Peso'" value="Porcentual">Porcentual</option>

									<option v-if="stepThree.niveles == 'Cantidad'" value="Monto por Cantidad">Monto por Cantidad</option>
									<option v-if="stepThree.niveles == 'Cantidad'" Value="Monto Fijo">Monto Fijo</option>
									<option v-if="stepThree.niveles == 'Cantidad'" value="Porcentual">Porcentual</option>

									<option v-if="stepThree.niveles == 'Monto'" Value="Monto Fijo">Monto Fijo</option>
									<option v-if="stepThree.niveles == 'Monto'" value="Porcentual">Porcentual</option>

								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div class="form-group" data-v-step="44">
								<label for="" class="control-label i">Tipo de Escala:</label>
								<select v-model="stepThree.tipoDeEscala" class="form-control">
									<option value="Escalonado">Escalonado</option>
									<option value="Retro to Nil">Retro to Nil</option>
								</select>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<label v-if="this.stepThree.niveles == ''" for="" class="control-label i">Moneda:</label>
								<label v-if="this.stepThree.niveles == 'Monto'" for="" class="control-label i">Moneda/UM:</label>
								<label v-if="this.stepThree.niveles == 'Cantidad'" for="" class="control-label i">EA:</label>
								<input v-model="stepThree.monedaUM" type="text" value="MXN" class="form-control width-75" readonly="">
							</div>
						</div>
						<div class="col-md-4" >

						</div>
					</div>
					<div class="row">
						<div class="col-md-9 table-options">
							<div class="buttons">
								<button> Export </button>
								<button data-v-step="47" @click="nuevoNivel = true"> Nuevo nivel </button>
								<button> Borrar línea </button>
							</div>
							<table class="table-proveedor table-not-hover">
								<tr>
									<td><i class="far fa-clone"></i></td>
									<td data-v-step="25">Valor Desde</td>
									<td data-v-step="26">Valor Hasta</td>
									<td data-v-step="27">Tarifa</td>
								</tr>
								<tr v-if="nuevoNivel || reviewApprove || stepThree.tarifa != ''">
									<td>&nbsp;</td>
									<td @input="onInputTipos($event,'valorDesde')" contenteditable="">
										{{stepThree.valorDesde}}
									</td>
									<td @input="onInputTipos($event,'valorHasta')" contenteditable="">
										{{stepThree.valorHasta}}
									</td>
									<td @input="onInputTipos($event,'tarifa')" contenteditable="">
										{{t == '' ? this.stepThree.tarifa:''}}
									</td>
								</tr>
								<tr v-if="!nuevoNivel && !reviewApprove && !stepThree.tarifa">
									<td>&nbsp;</td>
									<td colspan="3">La tabla no tiene datos.</td>
								</tr>
							</table>
							<add-exclude :tienda="52"/>
						</div>
					</div>
				</div>
				<div class="subtitle-content">
					Selección Tienda
				</div>
				<div class="col-md-9 mt-10">
					<div class="row">
						<div class="col-md-4">
							<div class="form-group" data-v-step="28">
								<label for="" class="control-label i">Región:</label>
								<input v-model="stepThree.region" type="text" class="form-control" value="">
								<div>
									<a class="a-blue-link">Añadir adicional</a>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group" data-v-step="29">
								<label for="" class="control-label i">Formato:</label>
								<input @focus="showFormato()" v-model="format" type="text" class="form-control paste" value="">
								<div>
									<a class="a-blue-link">Añadir adicional</a>
									<a class="a-blue-link">Seleccione Todo</a>
								</div>
							</div>
							<search-format @setFormato="setFormato($event)"/>
						</div>
						<div class="col-md-4">
							<div class="form-group" data-v-step="30">
								<label for="" class="control-label i">Tipo de Distribución:</label>
								<select class="form-control" v-model="stepThree.tipoDeDistribucion">
									<option value="Todas las tiendas">Todas las tiendas</option>
									<option value="Tiendas específicas">Tiendas específicas</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row mt-20">
						<div class="col-md-6 buttons">
							<button @click="tablaAportaciones = true" data-v-step="31"><i class="fas fa-save"></i> Guardar Aportación</button>
							<button data-v-step="46"><i class="fas fa-server"></i> Añadir nueva aportación</button>
						</div>
					</div>
				</div>
				<div class="subtitle-content">
					Guardar Aportaciones
				</div>
				<div v-if="tablaAportaciones || reviewApprove" class="row">
					<div class="col-md-9 table-options">
						<div class="buttons">
							<button> Export </button>
						</div>
						<table class="table-proveedor">
							<tr>
								<td>&nbsp;</td>
								<td>Acuerdo:</td>
								<td>Tipo de Aportación</td>
								<td>Descripción Aportación</td>
								<td>Fecha de Creación</td>
								<td>Fecha de modificación</td>
							</tr>
							<tr>
								<td>&nbsp;</td>
								<td></td>
								<td>{{stepThree.tipoDeAportacion.code}}</td>
								<td>{{stepThree.tipoDeAportacion.label}}</td>
								<td></td>
								<td></td>
							</tr>
						</table>
						<div class="buttons no-bg">
							<button><i class="fas fa-trash-alt"></i> Borrar Línea</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>





